(function ($) {

    $(function () {

        // Detect scroll header
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;

        const firstSectionHeight = $(".wp-block-cover:first").outerHeight();

        $(window).scroll(function (event) {
            didScroll = true;
        });

        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(window).scrollTop();

            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > (firstSectionHeight - 200)) {
                $('header').addClass('nav-bg');
            } else {
                $('header').removeClass('nav-bg');
            }
            let opacity = (st / 100) / 5;

            $(".header-bg").css("opacity", opacity);

            lastScrollTop = st;
        }

        //Smooth scroll
        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);
        });

        $('.nav-icon').click(function(){
            $(this).toggleClass("open");
            $(".header-nav").toggleClass("active");
        });

        $(".header-nav a").click(function() {
            $(".nav-icon").removeClass("open");
            $(".header-nav").removeClass("active");
        })

    });

})(jQuery);